import * as React from "react";
import { AuditForm } from "../auditmodal/components/AuditModal";
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";
import { ErrorBoundary } from "../errors/ErrorBoundary";
import Modal from "../misc/components/modal";

export interface ReviewAnnotationDialogProps {
    onClose: () => void;
    onSubmit: (values: AuditForm) => void;
}

export const ReviewAnnotationDialog = ({ onClose, onSubmit }: ReviewAnnotationDialogProps) => {

    return (
        <Modal show={true} header="Disagree with ECG Analysis" closeModalHandler={onClose}>
            <ErrorBoundary>
                <AuditModalBody isSubmitting={false} onClose={onClose} onSubmit={onSubmit}>
                    Please enter a comment to notify the analyst why you are disagreeing with the analysis of this ECG recording
                </AuditModalBody>
            </ErrorBoundary>
        </Modal>      
    );
}
